export const emited = {
	details: "Detalles de emisiones",
	fiscalGroup: "Emisiones por grupo fiscal",
	fiscalProfile: "Emisiones por perfil fiscal",
	byBars: "Emisiones por Bar",
	byEmployee: "Emisiones por empleado",
	foreignDescription:
		"Este informe presenta un detalle agregado del valor bruto emitido y del valor neto emitido. Muestra una agrupación por perfil fiscal, grupo fiscal de producto, bar, empleado y método de pago.",
	sheets: {
		details: {
			columns: {
				description: "Descripción",
				financialValue: "Valor financiero",
				title: "Título",
				unitValue: "Valor unidad",
				name: "Perfil fiscal",
				value: "Valor Emitido",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
			filename: "detalles_de_emisiones",
			title: "Detalles de Emisiones",
		},
		fiscalGroup: {
			columns: {
				name: "Grupo de productos",
				value: "Valor",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
			filename: "emisiones_por_grupo_fiscal",
			title: "Emisiones por grupo fiscal",
		},
		byBars: {
			title: "Emisiones por bar",
			filename: "emisiones_por_bar",
			columns: {
				name: "Bar",
				value: "Valor",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
		},
		byEmployee: {
			title: "Emisiones por empleado",
			filename: "Emisiones_por_empleado",
			columns: {
				name: "Empleado",
				value: "Valor",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
		},
		fiscalProfile: {
			columns: {
				name: "Perfil fiscal",
				value: "Valor Emitido",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
			filename: "emisiones_por_perfil_fiscal",
			title: "Emisiones por perfil fiscal",
		},
	},
	title: "Emisiones",
	subtitle: "Este informe considera solo las notas emitidas bajo el régimen NFC-e",
	table: {
		title: "Título",
		value: "Valor",
		valueForeign: "Valor Emitido Bruto",
		netValueForeign: "Valor Emitido Neto",
		fiscalGroups: {
			columns: {
				name: "Grupo fiscal",
				value: "Valor",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
		},
		fiscalProfiles: {
			columns: {
				name: "Perfil fiscal",
				value: "Valor Emitido",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
		},
		byBars: {
			columns: {
				name: "Bar",
				value: "Valor Emitido",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
		},
		byEmployee: {
			columns: {
				name: "Empleado",
				value: "Valor Emitido",
				valueForeign: "Valor Emitido Bruto",
				netValueForeign: "Valor Emitido Neto",
			},
		},
	},
};
